import { decode } from 'html-entities'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import { useTranslation } from 'react-i18next'
import { redirectToPage } from 'srcReact/helpers/history'
import {
  chunkArrayInGroups,
  getContentWithHighlightedText,
  getHighlightedSearchContent,
  matchedSearchInterestsInArray
} from 'srcReact/helpers/utils'
import dayjs from 'dayjs'
import { getCustomFormat1_SR, getDateFormat2 } from 'srcReact/helpers/datetimeHelper'
import AnchorLink from 'srcReact/components/common2/AnchorLink'

const Mixrs = ({
  id,
  scope,
  isHeader = false,
  isMobile,
  isNative,
  infiniteScrollRef,
  isBackNavigation,
  closeModal
}) => {
  const { t } = useTranslation()
  const iconSize = isHeader || isMobile ? 'medium' : 'large24'

  const {
    globalSearch: { searchInterestText, mixrs, results }
  } = useSelector((state) => state)
  const [recurrenceMixrId, setRecurrenceMixrId] = useState('')
  const [showAccordion, setShowAccordion] = useState(false)

  const handleClick = (e, mixr) => {
    e.preventDefault()
    setRecurrenceMixrId(mixr.id)
    setShowAccordion(recurrenceMixrId === mixr.id ? !showAccordion : true)
  }

  let searchedMixrs = mixrs
  if (scope === 'all') {
    searchedMixrs = mixrs.filter((m) => m.id === id)
  }

  return (
    <div className={styles.searchContentWrapper}>
      {searchedMixrs?.length > 0 &&
        searchedMixrs.map((m, i) => {
          const aboutText = results.find((res) => res.id === m.id && res.information_type === 'about')
          return (
            <AnchorLink
              key={i}
              // ${t('globalSearch.accessibility.mixrOfGroup', { groupName: m.group_name })}
              className={styles.mixrLinkWrapper}
              isNative={isNative}
              aria-label={`${
                m.recurrence_type === 'recurring'
                  ? t('globalSearch.accessibility.recurMixrDesc', {
                      mixrName: m.name,
                      startDate: getCustomFormat1_SR(m.recurrence_events[0].local_start_at),
                      endDate: getCustomFormat1_SR(m.recurrence_events[m.recurrence_events.length - 1].local_start_at)
                    })
                  : t('globalSearch.accessibility.mixrDesc', {
                      mixrName: m.name,
                      date: getCustomFormat1_SR(m.local_start_at)
                    })
              }  ${t('globalSearch.accessibility.mixrOfGroup', { groupName: m.group_name })}  ${
                m.mixr_over === 1 ? t('globalSearch.accessibility.mixrOver') : ''
              }`}
              backNavigation={isBackNavigation}
              ref={infiniteScrollRef}
              onMouseDown={(e) => e.preventDefault()}
              path={`/0/home/event/${m.id}`}
              {...(m.recurrence_type === 'recurring' ? { handleClick: (e) => handleClick(e, m) } : {})}>
              <div className={`${styles.searchContent} ${(isHeader || isMobile) && styles.headerContentWrapper}`}>
                <div className={styles.picture}>
                  {m.picture && m.picture.path ? (
                    <img src={m.picture.path} alt='' />
                  ) : (
                    <img src={require('srcReact/assets/images/background-default-mixr.jpg')} alt='' />
                  )}
                </div>

                <div className={styles.heading}>
                  <div className={styles.titleInterests}>
                    <div
                      className={styles.title}
                      dangerouslySetInnerHTML={{
                        __html: getContentWithHighlightedText(`${decode(m.name)}`, searchInterestText)
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: getHighlightedSearchContent(
                          `${decode(m.name)}`,
                          matchedSearchInterestsInArray(m.interests, searchInterestText)
                        )
                      }}
                    />
                    {m.recurrence_type === 'recurring' && (
                      <div className={styles.recurrenceIcon}>
                        <Icon
                          name={m.id === recurrenceMixrId && showAccordion ? 'chevron-up24' : 'chevron-down24'}
                          size='large24'
                        />
                      </div>
                    )}
                  </div>
                  {aboutText && (
                    <div
                      className={styles.description}
                      dangerouslySetInnerHTML={{
                        __html: getContentWithHighlightedText(`${decode(aboutText.content)}`, searchInterestText, 15)
                      }}
                    />
                  )}
                </div>

                {!isHeader && !isMobile && (
                  <div className={styles.rightContent}>
                    <div className={styles.datetime}>
                      <Icon name='calendar24' size={iconSize} styleModifier={styles.customIcon} />
                      {dayjs(m.local_start_at).format(getDateFormat2())}
                    </div>
                    <div className={styles.groupName}>
                      <Icon name='groups24' size={iconSize} styleModifier={styles.customIcon} />
                      {decode(m.group_name)}
                    </div>
                  </div>
                )}

                <div className={`${styles.overlay} ${m.is_over === 1 && styles.isOver}`}>
                  {m.recurrence_type === 'recurring' ? (
                    <Icon name='recurring-mixrs' size={iconSize} styleModifier={styles.customIcon} />
                  ) : (
                    <Icon name='calendar24' size={iconSize} styleModifier={styles.customIcon} />
                  )}
                </div>
              </div>

              {m.id === recurrenceMixrId && showAccordion && (isHeader || isMobile) && (
                <div className={styles.recurrenceContentHeadingWrapper}>
                  <div className={styles.datetime}>
                    <Icon name='calendar24' size='large24' styleModifier={styles.customIcon} />
                    {dayjs(m.local_start_at).format(getDateFormat2())}
                  </div>
                  <div className={styles.groupName}>
                    <Icon name='groups24' size='large24' styleModifier={styles.customIcon} />
                    {decode(m.group_name)}
                  </div>
                </div>
              )}

              <div className={styles.recurrenceContentWrapper}>
                {m.id === recurrenceMixrId &&
                  showAccordion &&
                  m.recurrence_events.length >= 1 &&
                  chunkArrayInGroups(
                    m.recurrence_events,
                    m.recurrence_events.length / (m.recurrence_events.length < 3 || isMobile || isHeader ? 2 : 3)
                  ).map((arr, index) => {
                    return (
                      <div className={`${styles.recurrenceContentColumn} ${isHeader && styles.isHeader}`} key={index}>
                        {arr.map((rec, idx) => (
                          <AnchorLink
                            aria-label={`${t('globalSearch.accessibility.recurChildMixr', {
                              mixrName: m.name,
                              date: getCustomFormat1_SR(rec.local_start_at)
                            })} ${rec.mixr_over === 1 ? t('globalSearch.accessibility.mixrOver') : ''}`}
                            className={styles.recurrenceContent}
                            isNative={isNative}
                            backNavigation={isBackNavigation}
                            path={`/0/home/event/${rec.id}`}
                            key={idx}
                            handleClick={() => {
                              if (closeModal) {
                                closeModal()
                              }
                            }}>
                            {rec.picture && rec.picture.path ? (
                              <img src={r.picture.path} alt={decode(rec.name)} className={styles.picture} />
                            ) : (
                              <img
                                src={require('srcReact/assets/images/background-default-mixr.jpg')}
                                alt='default'
                                className={styles.picture}
                              />
                            )}
                            <div className={styles.datetime}>{dayjs(rec.local_start_at).format(getDateFormat2())}</div>
                            <div className={styles.recurrenceIcon}>
                              <Icon name='arrow-right' size='large24' styleModifier={styles.customIcon} />
                            </div>
                            <div className={`${styles.overlay} ${rec.mixr_over === 1 && styles.isOver}`}>
                              <Icon name='recurring-mixrs' size='medium' styleModifier={styles.customIcon} />
                            </div>
                          </AnchorLink>
                        ))}
                      </div>
                    )
                  })}
              </div>
            </AnchorLink>
          )
        })}
    </div>
  )
}

export default Mixrs
